export function transformTestCases(testCases) {
    if (!testCases) return [];

    const keys = Object.keys(testCases);
    if (keys.length === 0) return [];

    const caseCount = testCases[keys[0]].length;

    const transformedCases = [];
    for (let i = 0; i < caseCount; i++) {
        const testCase = {};
        keys.forEach(key => {
            testCase[key] = testCases[key][i];
        });
        transformedCases.push(testCase);
    }
    return transformedCases;
}

export const getSubmitCodeHelper = (language, starterCode) => {
    const extractFunctionName = (code) => {
        const lines = code.split('\n');

        for (let line of lines) {
            line = line.trim();
            if (language === 'python' && line.startsWith('def ')) {
                return line.split(' ')[1].split('(')[0];
            } else if ((language === 'cpp' || language === 'java') && line.includes('(') && line.includes(')')) {
                const parts = line.split(' ');
                for (let part of parts) {
                    if (part.includes('(')) {
                        return part.split('(')[0];
                    }
                }
            }
        }
        return '';
    };

    let methodName = '';
    
    if (language === 'python') {
        methodName = extractFunctionName(starterCode['python']);
        return `\nsolution = Solution()\nprint(solution.${methodName}(`;
    } else if (language === 'cpp') {
        methodName = extractFunctionName(starterCode['cpp']);
        return `\nint main() {\n    Solution solution;\n    std::cout << solution.${methodName}(`;
    } else if (language === 'java') {
        methodName = extractFunctionName(starterCode['java']);
        return `\npublic class Main {\n    public static void main(String[] args) {\n        Solution solution = new Solution();\n        System.out.println(solution.${methodName}(`;
    }
    
    return '';
};